import type {ProCoverageItem, ProMapPolygon} from './types';

import {getColorToken} from '@ds/utils';
import {convertH3CellsToMultiplePolygons} from 'utils/geojson';
import {getSelectedVendorFromStorage} from 'utils/Helper';

import {PRO_ZONE_COLOR_TOKENS} from './constants';

export const getProVendorId = (): string | number => {
  const vendorId = getSelectedVendorFromStorage()?.id;

  return typeof vendorId === 'string' || typeof vendorId === 'number' ? vendorId : '0';
};

export const getCoveragePolygonIds = (items?: ProCoverageItem[]): Array<string | number> => {
  if (!items?.length) {
    return [];
  }

  return items.flatMap((item) => (item.polygons || []).map((polygon) => polygon.polygon_id));
};

export const getProZoneMapColor = (type: string): string | undefined => {
  const token = PRO_ZONE_COLOR_TOKENS[type];

  return token ? getColorToken(token) : undefined;
};

export const buildCoverageMapPolygons = (
  items?: ProCoverageItem[],
  selectedPolygonIds: Array<string | number> = [],
  colorSelectedOnly = false
): ProMapPolygon[] => {
  if (!items?.length) {
    return [];
  }

  const polygons: ProMapPolygon[] = [];

  items.forEach((item) => {
    item.polygons.forEach((polygon, index) => {
      const h3Polygons = convertH3CellsToMultiplePolygons(polygon.cells || []);
      const isSelected = selectedPolygonIds.includes(polygon.polygon_id);
      const polygonColor = getProZoneMapColor(item.type);
      const shouldColor = Boolean(polygonColor) && (isSelected || !colorSelectedOnly);

      h3Polygons.forEach((points, polygonIndex) => {
        polygons.push({
          points: points as [number, number][],
          id: `${polygon.polygon_id}-${polygonIndex}`,
          groupId: polygon.polygon_id,
          label: index + 1,
          isActivated: true,
          ...(shouldColor ? {polygonColor} : {})
        });
      });
    });
  });

  return polygons;
};
